class API {
	static path(path, params) {
		params = params ? new URLSearchParams(params) : new URLSearchParams();
		if (typeof nav != 'undefined') {
			params = nav.params(params);
		}
		return `/api/${path}?${params}`;
	}

	static async fetch(path, params, signal) {
		if (typeof signal === undefined) signal = null;

		try {
			return await API.handle(
				await fetch(
					API.path(path, params ?? false),
					{ signal }
				)
			);
		}
		catch (e) {
			return {abort: true};
		}
	}

	static async insert(path, json, params) {
		return await API.handle(
			await fetch(
				API.path(path, params ?? false),
				{
					method: 'POST',
					headers: {'content-type': 'application/json'},
					body: JSON.stringify(json)
				}
			)
		);
	}

	static async update(path, json, params) {
		return await API.handle(
			await fetch(
				API.path(path, params ?? false),
				{
					method: 'PUT',
					headers: {'content-type': 'application/json'},
					body: JSON.stringify(json)
				}
			)
		);
	}

	static async upsert(path, id, json, params) {
		path = !id ? path : `${path}/${id}`;
		return id ? API.update(path, json, params?? false) : API.insert(path, json, params?? false);
	}

	static async delete(path, json) {
		let init = typeof json === 'undefined'
			? {method: 'DELETE'}
			: {
				method: 'DELETE',
				headers: {'content-type':'application/json'},
				body: JSON.stringify(json)
			};
		
		return await API.handle(
			await fetch(API.path(path, '', new URLSearchParams), init)
		);
	}
	
	static async handle(response) {
		if (response.ok) {
			let json = await response.json();
			if (json.toasts && Array.isArray(json.toasts)) {
				for (let t of json.toasts) makeToast(t);
			}
			return json;
		}
		else if (response.status == 401) {
			window.location.href = 'sign-in';
			return false;
		}
		makeToast('Unknown error!<br>Please refresh the page and try again.');
		if (Sentry?? false) Sentry.captureMessage(`API error response \nStatus: ${response.status} \nMessage: ${response.statusText}`);
		return false;
	}
}